import React from "react";

import "../../App.css";

import Button from "@mui/material/Button";

import { useHistory, useLocation } from "react-router-dom";

import { Checkbox } from "@mui/material";

import { useState, useEffect, useRef } from "react";

import CircularProgress from "@mui/material/CircularProgress";

import Modal from "@mui/material/Modal";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { Dialog } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import RemoveIcon from "@mui/icons-material/Remove";

import { LinearProgress } from "@mui/material";

import CheckBoxIcon from "@mui/icons-material/CheckBox";

import InstaColors, {
  DeleteButton,
  EditButton,
  fontFamily,
  paddingAndMargin,
  reviewScreenButtonWithColor,
  reviewScreenButtonWithOutColor,
  screenHeaderStyle,
  UpperLowerText,
  useSharedValue,
} from "../Constants/constants";

import { ConditionalPagination } from "../../utils/paginationUtils";

import "../App.css";

import { handleFileDelete } from "../../services/deleteService";
import DeleteModal from "../Models/Delete/DeleteModal";
import { ParallelProcessModal } from "../Models/Parallel Process Modal/ParallelProcessModal.tsx";
import AltVendorIDModal from "./AltVendorIDModal";
import {
  handleFileUpload,
  getUploadTypeDisplayName,
  columns,
  getFormTypeDisplayName,
} from "../../Controller/fileController.tsx";
import { uploadExcelForMapping } from "../../services/deloitteService.tsx";
import { importFileData } from "../../services/fileDataService.tsx";
import { v4 as uuidv4 } from "uuid";

import SearchInput from "../Constants/search_input";

import { formatDate, getAllFilesList } from "../../Utility/utility";

import LoaderComponent from "./loader";

import Loader from "../../Utility/loading";

import "../App.css";

import { uploadPreLoadedFiles, getUserFileAuditByUserId } from "../../API_Endpoints/APIEndpoints";

import { handleLogout } from "../../Utility/utility";

export default function WorkloadFileImport() {
  const [isLoading, setIsLoading] = useState(false);

  const { selectedRows, handleSelectedRows } = useSharedValue();

  const { notifications, handleNotificationList } = useSharedValue();

  const [temporarySelectedRows, setTemporarySelectedRows] = useState([]);

  const { selectedRow } = useSharedValue();

  const { successFilename } = useSharedValue();

  const { isSuccessPopup, handleIsSuccessPopup } = useSharedValue();

  const { DataExtractProcess } = useSharedValue();
  const { storeReports } = useSharedValue();

  // const { searchValue } = useSharedValue();

  const processContainerRef = useRef(null);

  const [searchValue, setSearchValue] = useState("");

  const [selectDeletedItem, setSelectDeletedItem] = useState(null);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [editingData, setEditingData] = React.useState(null);

  const [userName, setUserName] = useState("");

  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);

  const { defaultBusinessunit, defaultOrganization, defaultUser, businessUnitsList } =
    useSharedValue();

  const [userId, setuserId] = useState(null);

  const [rows, setRows] = useState([]);

  const [allFiles, setAllFiles] = useState([]);

  const { isMenuOpen } = useSharedValue();

  const [fileName, setFileName] = React.useState("");

  const [businessUnits, setBusinessUnits] = React.useState([]);

  const [id, setId] = React.useState("");

  const [businessUnit, setBusinessUnit] = React.useState("");

  const [numberOfDataRows, setDataRows] = React.useState("");

  const [numberOfTiers, setTiers] = React.useState("");

  // const classes = useStyles();

  const [isCheckedAll, setIsCheckedAll] = useState(false);

  const [uploadedDate, setUploadedDate] = React.useState("");

  const [processIdentifier, setProcessIdentifier] = React.useState("AI Extrcator - I");

  const [units, setUnits] = React.useState(["Select"]);

  const process = ["DOC-AI", "GPT-AI"];

  const { numberOfSelectedRows, updateRowNumberOfPages } = useSharedValue();

  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value

  const [currentPage, setCurrentPage] = useState(1); // Current page number

  const [endIndex, setEndIndex] = useState(10);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const history = useHistory();
  const location = useLocation();
  const hasProcessedExtractData = useRef(false);
  const [pendingExtractFileId, setPendingExtractFileId] = useState(null);

  const [loading, setLoading] = useState(true);

  const { isRunProcessStarted } = useSharedValue();

  const {
    isProcessing,
    processStates,
    handleProcessingDialogue,
    metricsList,
    isPackProcessStarted,
  } = useSharedValue();

  const [totalFiles, setTotalFiles] = useState(null);

  const [totalForms, setTotalForms] = useState(null);

  const [totalIDDocuemnts, setTotalIDDocuemnts] = useState(null);

  const [totalWithholdings, setTotalWithholdings] = useState(null);

  const [formTypeCounts, setFormTypeCounts] = useState({});

  const [isDeleting, setIsDeleting] = useState(false);

  // State for tracking parallel upload progress
  const [uploadProgress, setUploadProgress] = useState({});
  const [isParallelUploading, setIsParallelUploading] = useState(false);

  // State for AltVendorID modal (for upload type 13)
  const [isAltVendorIDModalOpen, setIsAltVendorIDModalOpen] = useState(false);
  const [pendingAltVendorIDRows, setPendingAltVendorIDRows] = useState(null);

  // Add this function to reset all statistics

  const resetAllStatistics = () => {
    setTotalFiles(null);

    setTotalForms(null);

    setTotalWithholdings(null);

    setTotalIDDocuemnts(null);

    setFormTypeCounts({});

    // Reset any other statistics or state values
  };

  // Add timer state variables for tracking processing time

  const [processingStartTime, setProcessingStartTime] = useState(null);

  const [elapsedTime, setElapsedTime] = useState(0);

  const [timerInterval, setTimerInterval] = useState(null);

  // Format elapsed time as MM:SS or HH:MM:SS if over an hour

  // Start timer when processing begins

  useEffect(() => {
    if (isProcessing && !processingStartTime) {
      const startTime = Date.now();

      setProcessingStartTime(startTime);

      setElapsedTime(0);

      // Create interval to update elapsed time every second

      const interval = setInterval(() => {
        const now = Date.now();

        const elapsed = Math.floor((now - startTime) / 1000);

        setElapsedTime(elapsed);
      }, 1000);

      setTimerInterval(interval);
    } else if (!isProcessing && timerInterval) {
      // Clear timer when processing stops

      clearInterval(timerInterval);

      setTimerInterval(null);

      setProcessingStartTime(null);

      setElapsedTime(0);
    }

    // Cleanup on unmount

    return () => {
      if (timerInterval) {
        clearInterval(timerInterval);
      }
    };
  }, [isProcessing, processingStartTime, timerInterval]);

  // Handle Extract Data navigation - auto-select row and run process
  useEffect(() => {
    // Log the boolean parameter to track Extract Data vs Save button
    const isExtractDataClicked = location.state?.isExtractDataClicked;
    const fileImportId = location.state?.fileImportId;

    // Only proceed if we have valid state and it's Extract Data click and haven't processed this request yet
    if (
      isExtractDataClicked === true &&
      fileImportId &&
      rows.length > 0 &&
      !hasProcessedExtractData.current
    ) {
      hasProcessedExtractData.current = true; // Mark as processed to prevent multiple executions
      const fileId = location.state.fileImportId;

      // Find the target row
      const targetRow = rows.find((row) => row.fileImportId === fileId);
      if (targetRow) {
        // Select the row
        handleSelectedRows([fileId]);

        // Store the fileId for the useEffect to pick up
        setPendingExtractFileId(fileId);
      } else {
        console.log("❌ File not found in rows for fileImportId:", fileId);
      }
    } else if (isExtractDataClicked === false) {
      console.log("💾 Save button clicked - no extraction needed");
    } else if (isExtractDataClicked === undefined) {
      console.log("🧹 State cleared - no action needed");
    } else if (hasProcessedExtractData.current) {
      console.log("🔄 Already processed extract data request - skipping");
    } else {
      console.log("⏳ Waiting for valid state or rows to load...");
    }
  }, [location.state, rows, handleSelectedRows, DataExtractProcess, history]);

  // Reset the processed flag when location state is cleared
  useEffect(() => {
    if (!location.state || Object.keys(location.state).length === 0) {
      hasProcessedExtractData.current = false;
    }
  }, [location.state]);

  // Watch for selectedRows changes and trigger extraction when pending file is selected
  useEffect(() => {
    if (pendingExtractFileId && selectedRows && selectedRows.includes(pendingExtractFileId)) {
      try {
        // Check if the selected file has uploadType 13
        const selectedRow = rows.find((row) => row.fileImportId === pendingExtractFileId);

        if (selectedRow && selectedRow.uploadType === 13) {
          // Show AltVendorID modal for uploadType 13
          setPendingAltVendorIDRows(rows);
          setIsAltVendorIDModalOpen(true);
          setPendingExtractFileId(null);
        } else {
          // Normal extraction for other upload types
          DataExtractProcess(rows);

          // Clear the pending fileId
          setPendingExtractFileId(null);

          // Clear the state after successful extraction start
          setTimeout(() => {
            history.replace(location.pathname, {});
          }, 1000);
        }
      } catch (error) {
        console.error("❌ Error calling DataExtractProcess from selectedRows watcher:", error);
      }
    }
  }, [selectedRows, pendingExtractFileId, rows, DataExtractProcess, history, location.pathname]);

  useEffect(() => {
    // Only run this effect when isProcessing changes from true to false

    if (isPackProcessStarted === true) {
      resetAllStatistics();
    }
  }, [isPackProcessStarted]);

  useEffect(() => {
    if (metricsList.length > 1) {
      const withholdingDocs = metricsList.filter((doc) => doc.doc_type === "Withholding Statement");

      const otherDocs = metricsList.filter(
        (doc) => doc.doc_type !== "Withholding Statement" && doc.doc_type !== "ID Documents"
      );

      const idDocuemnts = metricsList.filter((doc) => doc.doc_type === "ID Documents");

      setTotalFiles(metricsList.length);

      setTotalForms(otherDocs.length);

      setTotalIDDocuemnts(idDocuemnts.length);

      setTotalWithholdings(withholdingDocs.length);

      const newFormTypeCounts = {};

      otherDocs.forEach((doc) => {
        const formType = getFormTypeDisplayName(doc.doc_type);

        if (formType) {
          newFormTypeCounts[formType] = (newFormTypeCounts[formType] || 0) + 1;
        }
      });

      setFormTypeCounts(newFormTypeCounts);
    }
  }, [metricsList]);

  useEffect(() => {
    if (processContainerRef.current) {
      processContainerRef.current.scrollTop = processContainerRef.current.scrollHeight;
    }
  }, [processStates]);

  const ProcessItem = ({ status, label }) => (
    <div
      style={{
        display: "flex",

        alignItems: "center",

        justifyContent: "space-between",

        padding: "12px",

        borderBottom: `1px solid ${InstaColors.button_background}`,

        minWidth: "400px",
      }}
    >
      <span
        style={{
          fontFamily: fontFamily,

          fontSize: "14px",

          color:
            status === "complete" ? InstaColors.primary : status === "failed" ? "#d32f2f" : "black",
        }}
      >
        {label}
      </span>

      {/* Wrapper for icons and loader */}

      <div
        style={{
          width: "24px",

          height: "24px",

          display: "flex",

          alignItems: "center",

          justifyContent: "center",

          position: "relative",
        }}
      >
        {/* Grey circle background for loading state */}

        {status === "loading" && (
          <div
            style={{
              width: "20px",

              height: "20px",

              display: "flex",

              alignItems: "center",

              justifyContent: "center",

              position: "relative",

              border: "2px solid lightgray",

              borderRadius: "50%",
            }}
          >
            {/* Animated Loader */}

            <CircularProgress
              size={20}
              style={{ color: InstaColors.primary, position: "absolute" }}
            />
          </div>
        )}

        {/* Success Checkbox */}

        {status === "complete" && (
          <CheckBoxIcon style={{ color: InstaColors.primary, position: "absolute" }} />
        )}

        {/* Failed state with red close mark */}

        {status === "failed" && (
          <div style={{ position: "relative" }}>
            <CheckBoxIcon
              checked={false}
              style={{ color: "#d32f2f", position: "absolute", transform: "translate(-50%, -50%)" }}
            />

            <CloseIcon
              style={{
                color: "white",

                position: "absolute",

                fontSize: "14px",

                transform: "translate(-50%, -50%)",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );

  React.useEffect(() => {
    //getAllFiles();
  }, [isSuccessPopup, notifications]);

  React.useEffect(() => {
    setLoading(true);

    getAllFiles();
  }, [defaultBusinessunit, searchValue, defaultOrganization, defaultUser]);

  const getAllFiles = async () => {
    const userDataJSON = localStorage.getItem("token");

    const userData = JSON.parse(userDataJSON);

    try {
      const data = await getAllFilesList(
        history,
        defaultOrganization,
        defaultBusinessunit,
        defaultUser,
        1 // Status 1: File uploaded - not yet extracted
      );

      setAllFiles(data);

      const filteredRows = data.filter(
        (row) =>
          row.isProcessed === false &&
          row.fileName.toLowerCase().includes(searchValue.toLowerCase())
      );

      setRows(filteredRows);

      // Check if both current files and user audit history are empty

      if (data.length === 0) {
        try {
          const userAudit = await getUserFileAuditByUserId();

          if (userAudit.length === 0) {
            await uploadPreLoadedFiles();

            // Refresh the file list after uploading sample files

            const refreshedData = await getAllFilesList(
              history,
              defaultOrganization,
              defaultBusinessunit,
              defaultUser
            );

            setAllFiles(refreshedData);

            setRows(
              refreshedData.filter(
                (row) =>
                  row.isProcessed === false &&
                  row.fileName.toLowerCase().includes(searchValue.toLowerCase())
              )
            );
          }
        } catch (auditError) {
          console.error("❌ Error checking user audit:", auditError);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      if (error.message && error.message.includes("401")) {
        handleLogout(history);
      }
    } finally {
      // Ensure loading state is reset in all cases

      setLoading(false);
    }
  };

  // Labels to exclude from completion count

  const excludedLabels = [
    "Starting Form Extraction",

    "Validating all withholdings & consolidating them into one.",

    "Splitting Pack Completed",

    "Splitting Pack",

    "Generating Excel & XML files Complete",
  ];

  // Calculate completion progress

  const calculateProgress = () => {
    if (!processStates || processStates.length === 0) return 0;

    const relevantItems = processStates.filter((item) => !excludedLabels.includes(item.label));

    const completedItems = relevantItems.filter((item) => item.status === "complete");

    return relevantItems.length > 0 ? (completedItems.length / totalFiles) * 100 : 0;
  };

  const progressValue = calculateProgress();

  // Ensure processStates exists before filtering

  const completedCount = processStates
    ? processStates.filter(
        (item) => item.status === "complete" && !excludedLabels.includes(item.label)
      ).length
    : 0;

  //   const totalCount = processStates.filter((item) => !excludedLabels.includes(item.label)).length;

  React.useEffect(() => {
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      // Fetching data from the backend server
      (async () => {
        try {
          const { getBusinessUnits } = await import("../../Utility/utility");
          const data = await getBusinessUnits(userData.organizationId);

          const defaultOption = { id: "default", businessUnit: "Select a Business Unit" }; // Default option

          const transformedData = data.map((item) => ({
            id: item.businessUnitId,

            businessUnit: item.businessUnitName,
          }));

          // Prepend the default option to the beginning of the transformed data array

          const dataWithDefault = [defaultOption, ...transformedData];

          setBusinessUnits(dataWithDefault);

          if (dataWithDefault) {
            setUnits(dataWithDefault.map((item) => item.businessUnit));
          }

          // Here, you can transform the fetched data to match the format of your 'data' array.
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      })();
    }
  }, []);

  React.useEffect(() => {
    if (editingData) {
      setFileName(editingData.fileName);

      setId(editingData.fileImportId);

      setProcessIdentifier(editingData.processIdentifier);

      setBusinessUnit(editingData.businessUnit);

      setUploadedDate(editingData.uploadedDate);

      setDataRows(editingData.numberOfRows);

      setTiers(editingData.numberOfTiers);
    }
  }, [editingData]);

  React.useEffect(() => {
    if (!process.includes(processIdentifier)) {
      setProcessIdentifier(process[0]);
    }
  }, [processIdentifier, process]);

  React.useEffect(() => {
    if (!units.includes(businessUnit)) {
      setBusinessUnit(units[0]);
    }
  }, [businessUnit, units]);

  const handleEdit = (row) => {
    history.push({
      pathname: "/displayAndEditFile",

      state: {
        someValue: row,

        fromPage: "workloadFileImport",

        returnPath: "/workloadFileImport",
      },
    });
  };

  useEffect(() => {
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      setUserName(userData.firstName + " " + userData.lastName);

      setuserId(userData.userId);
    }
  }, []);

  useEffect(() => {
    if (isRunProcessStarted == false) {
      handleSelectedRows([]);

      setIsCheckedAll(false);

      setTemporarySelectedRows([]);
    }
  }, [isRunProcessStarted]);

  // This function handles the file upload with parallel processing
  // Now using centralized handler from fileController
  const handleFileChange = async (event) => {
    await handleFileUpload(event, {
      mode: "workload",
      userId: userId,
      userName: userName,
      businessUnitsList: businessUnitsList,
      defaultBusinessunit: defaultBusinessunit,
      setIsParallelUploading: setIsParallelUploading,
      setUploadProgress: setUploadProgress,
      rows: rows,
      setRows: setRows,
      notifications: notifications,
      handleNotificationList: handleNotificationList,
      getAllFiles: getAllFiles,
      storeReports: storeReports,
      getUploadTypeDisplayName: getUploadTypeDisplayName,
    });
  };

  // Handle Deloitte Excel file uploads - parallel processing like regular file import
  const handleDeloitteFileChange = async (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    setIsParallelUploading(true);

    try {
      const fileArray = Array.from(files);

      // Initialize progress tracking for all files
      const initialProgress = {};
      fileArray.forEach((file, index) => {
        initialProgress[index] = {
          fileName: file.name,
          status: "pending",
          message: "Waiting to start...",
          progress: 0,
        };
      });
      setUploadProgress(initialProgress);

      // Get default business unit from user API - only use if available
      const { getDefaultBusinessUnit } = await import("../../Utility/utility");
      const firstBusinessUnit = (await getDefaultBusinessUnit()) || "";

      // Process all files in parallel
      const fileProcessingPromises = fileArray.map(async (file, index) => {
        try {
          // Check file type
          if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
            throw new Error("Only Excel files (.xlsx, .xls) are supported");
          }

          const fileId = uuidv4();

          // Update progress - uploading
          setUploadProgress((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              status: "processing",
              message: "Uploading Excel file...",
              progress: 33,
            },
          }));

          // Upload Excel file
          const uploadResult = await uploadExcelForMapping(file, fileId);

          // Update progress - storing data
          setUploadProgress((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              status: "processing",
              message: "Storing file data...",
              progress: 66,
            },
          }));

          // Create and store file import record with uploadType 13
          const newRow = {
            fileImportId: fileId,
            userId: userId,
            fileName: file.name,
            filePath: uploadResult.file_id || fileId,
            prcoessIdentifier: "DELOITTE-EXCEL",
            isProcessed: false,
            businessUnit: firstBusinessUnit,
            uploadedBy: userName,
            uploadedDate: new Date().toISOString(),
            reviewedBy: null,
            reviewedDate: null,
            numberOfFields: null,
            confidenceLevel: null,
            approvedBy: null,
            approvedDate: null,
            emailedTo: null,
            emailedDate: null,
            isInvestment: false,
            isWithholding: true,
            numberOfRows: null,
            numberOfTiers: null,
            uploadType: 13,
            rejectedBy: null,
            rejectedDate: null,
            accuracyPercentage: null,
            rejectionReason: "",
            notes: "Deloitte Excel Import - Ready for mapping",
            totalPages: 1,
            totalForms: 1,
            status: 1, // Status 1: File uploaded
          };

          await importFileData([newRow]);

          // Update progress - completed
          setUploadProgress((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              status: "completed",
              message: "Upload completed - ready for extraction",
              progress: 100,
            },
          }));

          return {
            success: true,
            fileName: file.name,
            fileId: fileId,
          };
        } catch (fileError) {
          console.error(`Error processing ${file.name}:`, fileError);
          setUploadProgress((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              status: "failed",
              message: fileError.message || "Upload failed",
              progress: 0,
            },
          }));

          return {
            success: false,
            fileName: file.name,
            error: fileError.message,
          };
        }
      });

      // Wait for all file processing to complete
      const results = await Promise.all(fileProcessingPromises);

      // Separate successful and failed uploads
      const successfulUploads = results.filter((result) => result.success);
      const failedUploads = results.filter((result) => !result.success);

      // Show results to user
      const resultNotifications = [];

      if (successfulUploads.length > 0) {
        resultNotifications.push({
          message: `Successfully uploaded ${successfulUploads.length} Deloitte file(s). Click 'Extract Data' to process them.`,
          type: "success",
        });
      }

      if (failedUploads.length > 0) {
        const failedFileNames = failedUploads.map((f) => f.fileName).join(", ");
        resultNotifications.push({
          message: `Failed to upload ${failedUploads.length} file(s): ${failedFileNames}`,
          type: "error",
        });
      }

      if (resultNotifications.length > 0) {
        handleNotificationList([
          ...(Array.isArray(notifications) ? notifications : []),
          ...resultNotifications,
        ]);
      }

      // Refresh file list
      await getAllFiles();

      // Reset file input
      event.target.value = "";
      setIsParallelUploading(false);
      setUploadProgress({});
    } catch (error) {
      console.error("Error in Deloitte file upload:", error);
      handleNotificationList([
        ...(Array.isArray(notifications) ? notifications : []),
        {
          message: `Error uploading Deloitte files: ${error.message}`,
          type: "error",
        },
      ]);
      setIsParallelUploading(false);
      setUploadProgress({});
      event.target.value = "";
    }
  };

  const handleRunProcess = async () => {
    // Filter rows to find files that are ready to process

    const readyToProcessFiles = rows.filter(
      (row) => row.isProcessed === false && row.businessUnit && row.isWithholding
    );

    if (readyToProcessFiles.length > 0) {
      // Check if any selected row has uploadType 13
      const hasUploadType13 = selectedRows.some((rowId) => {
        const row = rows.find((r) => r.fileImportId === rowId);
        return row && row.uploadType === 13;
      });

      if (hasUploadType13) {
        // Show AltVendorID modal for uploadType 13
        setPendingAltVendorIDRows(rows);
        setIsAltVendorIDModalOpen(true);
      } else {
        // Proceed with normal extraction
        await DataExtractProcess(rows);
      }
    } else {
      alert(
        "No files are ready to run process. Please ensure files have a client assigned and are recognized as withholding statements."
      );
    }
  };

  const handleAltVendorIDContinue = async (altVendorIDValues) => {
    // Close the modal
    setIsAltVendorIDModalOpen(false);

    // Update rows with AltVendorID values for uploadType 13 files
    const updatedRows = pendingAltVendorIDRows.map((row) => {
      if (row.uploadType === 13 && selectedRows.includes(row.fileImportId)) {
        return {
          ...row,
          altVendorID1: altVendorIDValues.AltVendorID1 || "",
          altVendorID2: altVendorIDValues.AltVendorID2 || "",
          altVendorID3: altVendorIDValues.AltVendorID3 || "",
        };
      }
      return row;
    });

    setRows(updatedRows);
    setPendingAltVendorIDRows(null);

    // Proceed with extraction
    await DataExtractProcess(updatedRows);

    // Clear location state if this was from auto-navigation
    setTimeout(() => {
      history.replace(location.pathname, {});
    }, 1000);
  };

  const handleColumnCheckboxChange = (e) => {
    if (e.target.checked) {
      // First check if there are any files that are ready to be selected

      const readyToSelectFiles = rows

        .filter((item) => item.isProcessed === false)

        .slice(startIndex, endIndex)

        .filter((row) => row.businessUnit && row.isWithholding);

      if (readyToSelectFiles.length === 0) {
        alert(
          "No files are ready to run process. Please ensure files have a client assigned and upload type is selected."
        );

        return;
      }

      setIsCheckedAll(e.target.checked);

      // Select all rows in the range that satisfy the conditions

      const selectedInRange = readyToSelectFiles.map((row) => row.fileImportId);

      handleSelectedRows(selectedInRange);

      setTemporarySelectedRows(selectedInRange);
    } else {
      setIsCheckedAll(false);

      // Deselect all rows

      handleSelectedRows([]);

      setTemporarySelectedRows([]);
    }
  };

  const handleRowCheckboxChange = (row) => {
    // Check for mandatory fields: businessUnit and uploadType

    if (!row.businessUnit || !row.uploadType) {
      const missingFields = [];

      if (!row.businessUnit) missingFields.push("business unit");

      if (!row.uploadType) missingFields.push("upload type");

      const userConfirmed = window.confirm(
        `This file is missing required information: ${missingFields.join(" and ")}. Would you like to edit this file to add the missing information?`
      );

      if (userConfirmed) {
        handleEdit(row);
      }

      return;
    }

    if (row.isWithholding === false) {
      alert(
        "This file could not been recognized as a withholding statement. Please try another file."
      );

      return;
    }

    let newRows = [...temporarySelectedRows];

    // Check if the row ID is already present in the array

    if (newRows.includes(row.fileImportId)) {
      newRows = newRows.filter((id) => id !== row.fileImportId);
    } else {
      newRows = [...newRows, row.fileImportId];
    }

    setTemporarySelectedRows(newRows);
    handleSelectedRows(newRows);
  };

  let totalPages = Math.ceil(rows.length / rowsPerPage);

  // Use centralized delete service
  const handleDelete = async () => {
    if (!selectDeletedItem) {
      return;
    }

    const rowToDelete = rows.find((row) => row.fileImportId === selectDeletedItem);

    await handleFileDelete({
      fileImportId: selectDeletedItem,
      fileName: rowToDelete?.fileName || "Unknown file",
      rows,
      setIsDeleting,
      getAllFiles,
      setIsPopupOpen,
    });
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);

    setStartIndex((parseInt(newPage) - 1) * numberOfSelectedRows);

    setEndIndex((parseInt(newPage) - 1) * numberOfSelectedRows + numberOfSelectedRows);
  };

  // Calculate total pages

  const handleRowsPerPageChange = (event) => {
    totalPages = Math.ceil(rows.length / parseInt(event.target.value));

    updateRowNumberOfPages(parseInt(event.target.value));

    setRowsPerPage(parseInt(event.target.value));

    setStartIndex(0);

    setCurrentPage(1);

    setEndIndex(parseInt(event.target.value));

    // Reset to the first page
  };

  // Overlay component

  const LoadingOverlay = () => (
    <div
      style={{
        position: "fixed",

        top: 0,

        width: isMenuOpen === true ? "calc(100vw - 240px)" : "calc(100vw - 72px)",

        left: isMenuOpen ? "240px" : "72px",

        height: "100%",

        zIndex: 9999,

        backgroundColor: "rgba(255, 255, 255, 0.5)", // You can adjust the color and opacity as needed
      }}
    >
      <div
        style={{
          position: "absolute",
          bottom: "50%",
          right: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {/* <CircularProgress style={{ color: '#2aa7e0', marginLeft: 30 }} /> */}

        <Loader />

        {/* {selectedRow && selectedRow !== null && (

                    <p style={{ marginTop: '10px', color: '#2aa7e0', fontFamily: fontFamily }}>Extracting data....</p>

                )} */}
      </div>
    </div>
  );

  return (
    <div style={screenHeaderStyle(isMenuOpen)}>
      {/* Loading overlay during deletion */}

      {isDeleting && (
        <div
          style={{
            position: "fixed",

            top: 0,

            left: 0,

            right: 0,

            bottom: 0,

            backgroundColor: "rgba(0, 0, 0, 0.1)",

            zIndex: 999,

            display: "flex",

            alignItems: "center",

            justifyContent: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "white",

              padding: "20px",

              borderRadius: "8px",

              display: "flex",

              alignItems: "center",

              gap: "10px",

              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <CircularProgress size={24} style={{ color: "#2aa7e0" }} />

            <span style={{ fontFamily: fontFamily, fontSize: "14px" }}>Deleting file...</span>
          </div>
        </div>
      )}

      {/* <Loader/> */}

      <div
        style={{
          marginTop: paddingAndMargin.headerTopHeight,
          marginBottom: paddingAndMargin.headerBelowHeight,
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          marginRight: 30,
          marginLeft: 30,
        }}
      >
        <SearchInput
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
          }}
          onClick={() => {
            setSearchValue("");
          }}
        />

        {/* Pagination Controls */}

        {rows.filter((item) => item.isProcessed === false).length > 5 && (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <label
                  style={{
                    fontFamily: "Poppins, sans-serif", // Add this line

                    fontWeight: 400,
                    fontSize: 12,
                  }}
                >
                  Displayed per page:&nbsp;
                  <select
                    className="pagination-select"
                    style={{ width: 50 }}
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                  >
                    {[5, 10, 15, 20, 25, 30].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
          </>
        )}

        {/* Centered buttons */}

        <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
          <Button variant="contained" component="label" style={reviewScreenButtonWithOutColor(155)}>
            Import File(s)
            {/* Hidden file input */}
            <input
              type="file"
              hidden
              multiple
              accept=".pdf,.xlsx,.docx"
              onChange={handleFileChange}
            />
          </Button>
          <Button variant="contained" component="label" style={reviewScreenButtonWithOutColor(165)}>
            Import Data
          
            <input
              type="file"
              hidden
              multiple
              accept=".pdf,.xlsx,.docx"
              onChange={handleDeloitteFileChange}
            />
          </Button>

          <Button
            style={reviewScreenButtonWithColor(140)}
            onClick={() => {
              handleRunProcess();
            }}
            variant="contained"
          >
            Extract Data
          </Button>
        </div>
      </div>

      {/* Main table container with fixed height */}
      <div
        style={{
          height: "calc(100vh - 220px)",
          display: "flex",
          flexDirection: "column",
          marginLeft: 0,
          marginRight: 0,
        }}
      >
        {/* Columns - Fixed Header */}
        <div class="columntitlesRowStyle" style={{ flexShrink: 0 }}>
          <div>
            <Checkbox
              size="small"
              checked={isCheckedAll}
              onChange={(event) => {
                handleColumnCheckboxChange(event);
              }}
              disabled={rows.length > 0 ? false : true}
              style={{ color: InstaColors.white }}
            />
          </div>

          {columns.map((column) => (
            <div key={column.field} class="columntitlesStyle">
              <UpperLowerText text={column.headerName} />
            </div>
          ))}
        </div>

        {/* Table rows container - Scrollable */}
        {loading ? (
          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Loader />
          </div>
        ) : rows.length === 0 ? (
          <div
            className="no-record"
            style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            There are no records available.
          </div>
        ) : (
          <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
            {/* </div> */}

            {/* Displaying rows */}

            {rows
              .filter((item) => item.isProcessed === false)
              .slice(startIndex, endIndex)
              .map((row) => (
                <div key={row.fileImportId} class="columnRowStyle">
                  <div>
                    <Checkbox
                      size="small"
                      title="Select"
                      onChange={() => {
                        handleRowCheckboxChange(row);
                      }}
                      style={{
                        color:
                          selectedRows.includes(row.fileImportId) && isRunProcessStarted
                            ? "#ccc"
                            : "#2aa7e0",
                      }}
                      disabled={selectedRows.includes(row.fileImportId) && isRunProcessStarted}
                      checked={selectedRows.includes(row.fileImportId)}

                      // checked={selectedRow && selectedRow.fileImportId === row.fileImportId}
                    />
                  </div>

                  {columns.map((column) => (
                    <div
                      key={column.field}
                      title={
                        column.headerName === "Uploaded Date"
                          ? formatDate(row[column.field])
                          : column.field === "uploadType"
                            ? getUploadTypeDisplayName(row[column.field])
                            : row[column.field]
                      }
                      class="columnValuesStyle"
                    >
                      {/* Custom rendering for PROCESS QUEUE column */}

                      {column.field === "processQueue" ? (
                        <div style={{ display: "flex", alignItems: "flex-end" }}>
                          <div style={{ marginRight: "auto" }}></div>

                          <EditButton onClick={() => handleEdit(row)} />

                          <DeleteButton
                            onClick={() => {
                              setIsPopupOpen(true);

                              setSelectDeletedItem(row.fileImportId);
                            }}
                          />
                        </div>
                      ) : column.field === "processStatus" ? (
                        <div>
                          {selectedRows.includes(row.fileImportId) &&
                          selectedRow?.fileImportId === row.fileImportId &&
                          isRunProcessStarted == true &&
                          isProcessing === false ? (
                            <>
                              <div
                                style={{
                                  float: "left",

                                  marginRight: 10,
                                }}
                              >
                                <LoaderComponent />{" "}
                              </div>

                              {/* <img src="process.gif" width="25px" /> */}

                              <span className="status status-primary">Processing</span>
                            </>
                          ) : !selectedRows.includes(row.fileImportId) ||
                            isRunProcessStarted == false ? (
                            <>
                              {row.businessUnit && row.isWithholding ? (
                                <span className="status status-success">Ready to process</span>
                              ) : (
                                <span className="status status-danger">Information required</span>
                              )}
                            </>
                          ) : (
                            isRunProcessStarted == true && (
                              <span className="status status-warning">
                                {isRunProcessStarted ? "Processing" : "In Queue"}
                              </span>
                            )
                          )}
                        </div>
                      ) : column.field === "uploadType" ? (
                        getUploadTypeDisplayName(row[column.field])
                      ) : column.headerName === "Uploaded Date" ? (
                        formatDate(row[column.field])
                      ) : (
                        row[column.field]
                      )}
                    </div>
                  ))}
                </div>
              ))}
          </div>
        )}
      </div>

      <Dialog
        open={isProcessing}
        PaperProps={{
          style: {
            borderRadius: paddingAndMargin.buutonBorderradius,

            padding: "20px",

            backgroundColor: "#ffffff",
          },
        }}
      >
        <div
          style={{
            position: "absolute",

            top: "10px",

            left: "10px",

            right: "10px",

            display: "flex",

            flexDirection: "row",

            justifyContent: "space-between",

            alignItems: "center",
          }}
        >
          {/* Time Display */}

          {processingStartTime && (
            <div
              style={{
                fontSize: "14px",

                color: InstaColors.primary,

                fontFamily: fontFamily,

                fontWeight: "500",
              }}
            >
              {/* {formatElapsedTime(elapsedTime)} */}
            </div>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {/* Minimize Icon */}
            <div
              style={{
                cursor: "pointer",
                padding: "4px",
                borderRadius: "4px",
                transition: "background-color 0.2s",
                width: "26px", // Fixed width
                height: "26px", // Fixed height
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => handleProcessingDialogue(false)}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(0,0,0,0.1)")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
            >
              <RemoveIcon
                style={{
                  fontSize: "18px",
                  color: InstaColors.primary,
                }}
              />
            </div>

            {/* Close Icon */}
            <div
              style={{
                cursor: "pointer",
                padding: "4px",
                borderRadius: "4px",
                transition: "background-color 0.2s",
                width: "26px", // Fixed width
                height: "26px", // Fixed height
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => {
                const confirmed = window.confirm(
                  "Are you sure you want to cancel the uploading files?"
                );
                if (confirmed) {
                  window.location.reload();
                }
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "rgba(0,0,0,0.1)")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
            >
              <CloseIcon
                style={{
                  fontSize: "18px",
                  color: InstaColors.primary,
                }}
              />
            </div>
          </div>
        </div>

        <div
          style={{
            width: "100%",

            textAlign: "center",

            marginBottom: "20px",

            marginTop: "8px",
          }}
        >
          <h3
            style={{
              fontFamily: fontFamily,

              fontSize: "16px",

              fontWeight: 500,

              color: InstaColors.primary,

              margin: 0,

              display: "inline-block",
            }}
          >
            {selectedRow?.fileName || "Processing Forms with Pack"}
          </h3>
        </div>

        {totalFiles !== null && totalFiles > 0 && (
          <div
            style={{
              marginBottom: "15px",

              display: "flex",

              flexDirection: "column",

              gap: "5px",
            }}
          >
            <LinearProgress
              variant="determinate"
              value={progressValue}
              style={{
                height: "8px",

                borderRadius: "4px",

                backgroundColor: "#e0e0e0",
              }}
            />

            <div
              style={{
                display: "flex",

                justifyContent: "space-between",

                fontSize: "14px",

                color: InstaColors.primary,

                fontWeight: 500,
              }}
            >
              <span>Progress</span>

              <span>
                {completedCount} of {totalFiles} completed
              </span>
            </div>
          </div>
        )}

        <div
          style={{
            display: "flex",

            flexDirection: "row",

            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            {totalFiles !== null && totalFiles > 0 && (
              <span style={{ color: InstaColors.primary, fontWeight: 500 }}>
                Total Files Split: {totalFiles}
              </span>
            )}

            {totalFiles !== null && totalForms > 0 && (
              <span style={{ color: InstaColors.primary, fontWeight: 500 }}>
                Total Forms: {totalForms}
              </span>
            )}

            {totalFiles !== null && totalWithholdings > 0 && (
              <span style={{ color: InstaColors.primary, fontWeight: 500 }}>
                Total Withholding Statement: {totalWithholdings}
              </span>
            )}

            {totalFiles !== null && totalIDDocuemnts > 0 && (
              <span style={{ color: InstaColors.primary, fontWeight: 500 }}>
                Total ID Docs: {totalIDDocuemnts}
              </span>
            )}
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            {Object.keys(formTypeCounts).length > 0 &&
              Object.entries(formTypeCounts).map(([type, count]) => (
                <div key={type}>
                  <span style={{ color: InstaColors.primary, fontWeight: 500 }}>
                    {getFormTypeDisplayName(type)}: {count}
                  </span>
                </div>
              ))}
          </div>
        </div>

        <div
          ref={processContainerRef}
          style={{
            minHeight: "200px",
            maxHeight: "350px",
            overflowY: "auto",
            paddingRight: "10px",
            marginTop: "15px",
          }}
        >
          <style></style>

          {processStates.map((item) => (
            <ProcessItem key={item.docPath} status={item.status} label={item.label} />
          ))}
        </div>
      </Dialog>

      <div style={{ marginBottom: "10px" }}></div>

      {isLoading && <LoadingOverlay />}

      <DeleteModal
        open={isPopupOpen}
        isDeleting={isDeleting}
        onClose={() => setIsPopupOpen(false)}
        onDelete={handleDelete}
        deleteButtonStyle={reviewScreenButtonWithColor(100)}
        cancelButtonStyle={reviewScreenButtonWithOutColor(100)}
      />

      <AltVendorIDModal
        open={isAltVendorIDModalOpen}
        onClose={() => {
          setIsAltVendorIDModalOpen(false);
          setPendingAltVendorIDRows(null);
        }}
        onContinue={handleAltVendorIDContinue}
      />

      <Modal
        open={isSuccessPopup}
        onClose={null} // Disable closing the modal on tapping outside
        disableBackdropClick={true}
        aria-labelledby="delete-confirmation-modal-title"
        aria-describedby="delete-confirmation-modal-description"
        style={{
          border: "none", // Remove border
          background: "transparent", // Remove background color
          boxShadow: "none",
        }}
      >
        <div
          style={{
            top: "50%",
            left: "50%",
            border: "none",
            transform: "translate(-50%, -50%)",
            position: "absolute",
            width: "450px",
            padding: "20px",
            outline: "none",
            backgroundColor: "white",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <CheckCircleIcon
              style={{ height: 40, width: 40, color: "green" }}
              className="text-green-500 mb-4 custom-bounce"
            />

            <h6 style={{ color: "#2aa7e0", fontFamily: fontFamily, marginBottom: 10 }}>
              {successFilename ?? ""}
            </h6>

            <h6 style={{ color: "#2aa7e0", fontFamily: fontFamily, marginBottom: 15 }}>SUCCESS</h6>
          </div>

          {/* <div style={{ height: '1px', width: '410px', backgroundColor: '#2aa7e0', marginBottom: '20px', marginRight: '10px', }}></div> */}

          <div>
            <div style={{ marginBottom: "20px" }}>
              <div
                style={{
                  marginLeft: "30px",
                  marginRight: "30px",
                  fontFamily: fontFamily,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                Extraction completed. The file has been successfully pushed to Extraction Review.
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
              <Button
                disableElevation
                variant="contained"
                style={reviewScreenButtonWithColor(180)}
                onClick={() => {
                  history.push({
                    pathname: "/extractionReview",
                  });

                  handleIsSuccessPopup(false);
                }}
              >
                Extraction Review
              </Button>

              <Button
                disableElevation
                variant="contained"
                style={reviewScreenButtonWithColor(180)}
                onClick={() => {
                  handleIsSuccessPopup(false);

                  getAllFiles();
                }}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Parallel Upload Progress Modal */}
      <ParallelProcessModal
        open={isParallelUploading}
        uploadProgress={uploadProgress}
        title="File Upload in Progress"
        uploadingMessage="files simultaneously..."
        processingMessage="Files are being processed in parallel for faster upload"
      />

      <ConditionalPagination
        itemCount={rows.filter((item) => item.isProcessed === false).length}
        itemsPerPage={rowsPerPage}
        threshold={rowsPerPage}
        paginationProps={{
          page: currentPage,
          onChange: handlePageChange,
          style: { marginLeft: "auto", marginRight: 10, marginTop: "auto", marginBottom: 10 },
        }}
      />
    </div>
  );
}
